// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ox-0";
export var animationContainer = "_ox-1";
export var itemPrice = "_ox-a";
export var itemizedContent = "_ox-9";
export var itemizedHeader = "_ox-7";
export var itemizedRow = "_ox-8";
export var itemizedSection = "_ox-6";
export var modalContent = "_ox-2";
export var orderName = "_ox-3";
export var refundOption = "_ox-4";
export var refundOptionsContainer = "_ox-5";
export var shippingLabel = "_ox-b";
export var totalRow = "_ox-c";